import codes from "../../errorCodes/Products";
export default function productsErrorHandler(code) {
    switch (code) {
        case codes.OrderNotFound:
            return "errors.PBPROOrderNotFound";
        case codes.ProductNotFound:
            return "errors.PBPROProductNotFound";
        case codes.InvalidJson:
            return "errors.PBPROInvalidJson";
        case codes.ResourceConflict:
            return "errors.PBPROResourceConflict";
        case codes.InvalidRestPagination:
            return "errors.PBPROInvalidRestPagination";
        case codes.DynamoAdapterWriteError:
            return "errors.PBPRODynamoAdapterWriteError";
        case codes.DynamoAdapterReadError:
            return "errors.PBPRODynamoAdapterReadError";
        case codes.DomainOrderItemsRequiredIfTimeNotNull:
            return "errors.PBPRODomainOrderItemsRequiredIfTimeNotNull";
        case codes.DomainOrderValueRequiredIfTimeNotNull:
            return "errors.PBPRODomainOrderValueRequiredIfTimeNotNull";
        case codes.RedemptionNotFound:
            return "errors.PBPRORedemptionNotFound";
        case codes.DealNotFound:
            return "errors.PBPRODealNotFound";
        case codes.OrderLimitsReachedAllTime:
            return "errors.PBPROOrderLimitsReachedAllTime";
        case codes.OrderLimitsReached:
            return "errors.PBPROOrderLimitsReached";
        case codes.ProductCinemaMetaDataLocationsError:
            return "errors.PBPROProductCinemaMetaDataLocationsError";
        case codes.ProductInvalidLocale:
            return "errors.PBPROProductInvalidLocale";
        case codes.OrderAppServiceNoProductsOnDeal:
            return "errors.PBPROOrderAppServiceNoProductsOnDeal";
        case codes.OrderAppServiceOrderExistsOnRedemption:
            return "errors.PBPROOrderAppServiceOrderExistsOnRedemption";
        case codes.ProductInvalidType:
            return "errors.PBPROProductInvalidType";
        case codes.ProductNameNotUnique:
            return "errors.PBPROProductNameNotUnique";
        case codes.ProductLocaleCannotBeChanged:
            return "errors.PBPROProductLocaleCannotBeChanged";
        case codes.ProductTypeCannotBeChanged:
            return "errors.PBPROProductTypeCannotBeChanged";
        case codes.ValidationError:
            return "errors.PBPROValidationError";
        case codes.ValidationInvalidName:
            return "errors.PBPROValidationInvalidName";
        case codes.ValidationInvalidType:
            return "errors.PBPROValidationInvalidType";
        case codes.ValidationInvalidSupplier:
            return "errors.PBPROValidationInvalidSupplier";
        case codes.ValidationInvalidVAT:
            return "errors.PBPROValidationInvalidVAT";
        case codes.ValidationInvalidSavings:
            return "errors.PBPROValidationInvalidSavings";
        case codes.ValidationInvalidData:
            return "errors.PBPROValidationInvalidData";
        case codes.ValidationInvalidCinemaMetadataEnabled:
            return "errors.PBPROValidationInvalidCinemaMetadataEnabled";
        case codes.ValidationInvalidCinemaMetadataLocations:
            return "errors.PBPROValidationInvalidCinemaMetadataLocations";
        case codes.ValidationInvalidCinemaMetadataLocationName:
            return "errors.PBPROValidationInvalidCinemaMetadataLocationName";
        case codes.ValidationInvalidCardImage:
            return "errors.PBPROValidationInvalidCardImage";
        case codes.BirthdayPerkAlreadyRedeemedWithinLastYear:
            return "errors.PBPROBirthdayPerkAlreadyRedeemedWithinLastYear";
        case codes.EventWindowDaysMustBePositiveNumber:
            return "errors.PBPROEventWindowDaysMustBePositiveNumber";
        case codes.EventWindowDateOfBirthIsNotSet:
            return "errors.PBPROEventWindowDateOfBirthIsNotSet";
        case codes.TodaysDateIsNotWithinRedemptionWindow:
            return "errors.PBPROTodaysDateIsNotWithinRedemptionWindow";
        case codes.ExternalItemNoLongerAvailable:
            return "errors.PBBROExternalItemNoLongerAvailable";
        case codes.OrderLimitsReachedCurrentTotalWithValueCurrency:
            return "errors.PBPROOrderLimitsReachedCurrentTotalWithValueCurrency";
        case codes.OrderLimitsReachedCurrentTotalWithValueCurrencyPeriod:
            return "errors.PBPROOrderLimitsReachedCurrentTotalWithValueCurrencyPeriod";
        case codes.OrderLimitsReachedCurrentTotalWithNumber:
            return "errors.PBPROOrderLimitsReachedCurrentTotalWithNumber";
        case codes.OrderLimitsReachedCurrentTotalWithNumberPeriod:
            return "errors.PBPROOrderLimitsReachedCurrentTotalWithNumberPeriod";
        case codes.OrderLimitsReachedOverTimeWithValueCurrencyPeriodHour:
            return "errors.PBPROOrderLimitsReachedOverTimeWithValueCurrencyPeriodHour";
        case codes.OrderLimitsReachedOverTimeWithValueCurrencyPeriodDay:
            return "errors.PBPROOrderLimitsReachedOverTimeWithValueCurrencyPeriodDay";
        case codes.OrderLimitsReachedOverTimeWithValueCurrencyPeriodSecond:
            return "errors.PBPROOrderLimitsReachedOverTimeWithValueCurrencyPeriodSecond";
        case codes.OrderLimitsReachedOverTimeWithValueCurrencyPeriodMinute:
            return "errors.PBPROOrderLimitsReachedOverTimeWithValueCurrencyPeriodMinute";
        case codes.OrderLimitsReachedOverTimeWithValueCurrencyPeriodDayHour:
            return "errors.PBPROOrderLimitsReachedOverTimeWithValueCurrencyPeriodDayHour";
        case codes.OrderLimitsReachedOverTimeWithValueCurrencyPeriodMinuteSecond:
            return "errors.PBPROOrderLimitsReachedOverTimeWithValueCurrencyPeriodMinuteSecond";
        case codes.OrderLimitsReachedAllTimeWithValueCurrency:
            return "errors.PBPROOrderLimitsReachedAllTimeWithValueCurrency";
        case codes.OrderLimitsReachedAllTimeWithValueCurrencyPeriod:
            return "errors.PBPROOrderLimitsReachedAllTimeWithValueCurrencyPeriod";
        case codes.OrderLimitsReachedOverTimeWithNumberPeriodHour:
            return "errors.PBPROOrderLimitsReachedOverTimeWithNumberPeriodHour";
        case codes.OrderLimitsReachedOverTimeWithNumberPeriodDay:
            return "errors.PBPROOrderLimitsReachedOverTimeWithNumberPeriodDay";
        case codes.OrderLimitsReachedOverTimeWithNumberPeriodSecond:
            return "errors.PBPROOrderLimitsReachedOverTimeWithNumberPeriodSecond";
        case codes.OrderLimitsReachedOverTimeWithNumberPeriodMinute:
            return "errors.PBPROOrderLimitsReachedOverTimeWithNumberPeriodMinute";
        case codes.OrderLimitsReachedOverTimeWithNumberPeriodDayHour:
            return "errors.PBPROOrderLimitsReachedOverTimeWithNumberPeriodDayHour";
        case codes.OrderLimitsReachedOverTimeWithNumberPeriodMinuteSecond:
            return "errors.PBPROOrderLimitsReachedOverTimeWithNumberPeriodMinuteSecond";
        case codes.OrderLimitsReachedAllTimeWithNumber:
            return "errors.PBPROOrderLimitsReachedAllTimeWithNumber";
        case codes.OrderLimitsReachedOverTimeWithNumberPeriod:
            return "errors.PBPROOrderLimitsReachedOverTimeWithNumberPeriod";
        case codes.OrderLimitsReachedWithNumberAllowed:
            return "errors.PBPROOrderLimitsReachedWithNumberAllowed";
        case codes.OrderLimitsReachedWithNumberPeriodAllowed:
            return "errors.PBPROOrderLimitsReachedWithNumberPeriodAllowed";
        case codes.OrderLimitsReachedWithValueCurrencyAllowed:
            return "errors.PBPROOrderLimitsReachedWithValueCurrencyAllowed";
        case codes.OrderLimitsReachedWithValueCurrencyPeriodAllowed:
            return "errors.PBPROOrderLimitsReachedWithValueCurrencyPeriodAllowed";
        default:
            return "";
    }
}
